import React from 'react';
import {
  Grid,
  Paper,
  Typography,
  Box,
  Card,
  CardContent,
} from '@mui/material';
import {
  People,
  AttachMoney,
  CalendarToday,
  Description,
} from '@mui/icons-material';

const Dashboard: React.FC = () => {
  const stats = [
    { title: 'Total de Sócios', value: '0', icon: <People />, color: '#1b4332' },
    { title: 'Receitas do Mês', value: 'R$ 0,00', icon: <AttachMoney />, color: '#2d6a4f' },
    { title: 'Agendamentos', value: '0', icon: <CalendarToday />, color: '#bc6c25' },
    { title: 'Documentos Pendentes', value: '0', icon: <Description />, color: '#9d0208' },
  ];

  return (
    <Box>
      <Typography variant="h4" gutterBottom sx={{ fontWeight: 700 }}>
        Dashboard
      </Typography>
      <Typography variant="body1" color="text.secondary" paragraph>
        Visão geral do sistema
      </Typography>

      <Grid container spacing={2.5} sx={{ mt: 1 }}>
        {stats.map((stat, index) => (
          <Grid size={{ xs: 12, sm: 6, md: 3 }} key={index}>
            <Card sx={{ height: '100%' }}>
              <CardContent>
                <Box display="flex" alignItems="center" justifyContent="space-between">
                  <Box>
                    <Typography color="text.secondary" gutterBottom variant="body2">
                      {stat.title}
                    </Typography>
                    <Typography variant="h4" sx={{ fontWeight: 700 }}>
                      {stat.value}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      color: stat.color,
                      bgcolor: `${stat.color}14`,
                      borderRadius: 2,
                      p: 1.25,
                      display: 'flex',
                    }}
                  >
                    {stat.icon}
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Grid container spacing={2.5} sx={{ mt: 1 }}>
        <Grid size={{ xs: 12, md: 6 }}>
          <Paper sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>
              Atividades Recentes
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Nenhuma atividade recente
            </Typography>
          </Paper>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Paper sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>
              Alertas
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Nenhum alerta no momento
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Dashboard;

